import { Button } from "primereact/button";
import { InstantQuotationVessel } from "../../types/quotations/InstantQuotationVessel";
import { getTranslationObject } from "../../services/Translation";
import { InputText } from "primereact/inputtext";
import { getFlagUrl } from "../../services/QuotationsServices";

const t = getTranslationObject();

export const vesselTemplate = (
    vessel: InstantQuotationVessel,
    handleSelectVessel: any
) => {
    return (
        <div className="col-12">
            <div className="flex align-items-center justify-content-between">
                {vesselInfoCard(vessel)}
                <div>
                    <Button
                        label={t("instantQuotation.vesselSearch.select")}
                        className="add-vessel-button"
                        onClick={() => handleSelectVessel(vessel)}
                    />
                </div>
            </div>
        </div>
    );
};

export const vesselInfoCard = (vessel: InstantQuotationVessel) => {
    const flagAspectRatio = 1.5;
    const flagHeight = 30;
    const flagWidth = flagHeight * flagAspectRatio;

    const flagSrc = vessel.FlagCode
        ? getFlagUrl(vessel.FlagCode)
        : getFlagUrl("unk");

    const defaultImage = (error: any) => {
        error.target.src = getFlagUrl("unk");
        error.target.onerror = null;
    };

    return (
        <div className="flex align-items-center">
            <div>
                <img
                    style={{
                        height: `${flagHeight}px`,
                        width: `${flagWidth}px`,
                        border: "1px solid lightgray"
                    }}
                    src={flagSrc}
                    onError={(e) => defaultImage(e)}
                />
            </div>
            <div className="ml-3">
                <div className="ship-name">{vessel.ShipName}</div>
                <div className="ship-details">
                    {vessel.LRIMOShipNo} •{" "}
                    {vessel.FlagName + " (" + vessel.FlagCode + ")"} •{" "}
                    {vessel.ShipTypeName}
                </div>
            </div>
        </div>
    );
};

export const finderHeader = (
    handleVesselSearchChange: any,
    previousSearch: string
) => {
    return (
        <div>
            <div className="col-12 mb-2">
                <span>{t("instantQuotation.vesselSearch.dialogTitle")}</span>
            </div>
            <div>
                <span className="p-input-icon-left w-full">
                    <i className="pi pi-search"></i>
                    <InputText
                        autoFocus
                        placeholder={t("instantQuotation.searchPlaceholder")}
                        className="w-full"
                        defaultValue={previousSearch}
                        onChange={handleVesselSearchChange}
                    />
                </span>
            </div>
        </div>
    );
};
